var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CPseudoBox',_vm._g(_vm._b({staticClass:"omt-grid",style:(_vm.gridStyle),attrs:{"pb":_vm.spacing && ['', (_vm.spacing + "px !important")]}},'CPseudoBox',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }